import { PurchaseOrderStatuses } from "@legacy/core/utils/enums"

import { ObjectsView } from "@organisms"

import { PURCHASE_ORDER_ROUTES } from "@routes/purchase-orders"

export const PurchaseOrderObjectsViewTabs = () => (
    <ObjectsView.Tabs>
        <ObjectsView.Tab
            id="all_open"
            phase="open"
            title="All Open"
            isDefaultActiveTabForPhase={true}
            endpointKwargs={[
                ["status", PurchaseOrderStatuses.pending],
                ["status", PurchaseOrderStatuses.sent],
                ["status", PurchaseOrderStatuses.acknowledged],
                ["status", PurchaseOrderStatuses.in_transit],
                ["status", PurchaseOrderStatuses.delivered],
                ["status", PurchaseOrderStatuses.stocked],
                ["ordering", "date_issued"],
            ]}
            listEndpoint={PURCHASE_ORDER_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PURCHASE_ORDER_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="pending"
            title="Pending"
            phase="open"
            endpointKwargs={[
                ["status", PurchaseOrderStatuses.pending],
                ["ordering", "date_issued"],
            ]}
            listEndpoint={PURCHASE_ORDER_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PURCHASE_ORDER_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="open"
            title="Open"
            phase="open"
            endpointKwargs={[
                ["status", PurchaseOrderStatuses.sent],
                ["status", PurchaseOrderStatuses.acknowledged],
                ["ordering", "date_issued"],
            ]}
            listEndpoint={PURCHASE_ORDER_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PURCHASE_ORDER_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="in_transit"
            title="In Transit"
            phase="open"
            endpointKwargs={[
                ["status", PurchaseOrderStatuses.in_transit],
                ["ordering", "date_issued"],
            ]}
            listEndpoint={PURCHASE_ORDER_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PURCHASE_ORDER_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="delivered"
            title="Delivered"
            phase="open"
            endpointKwargs={[
                ["status", PurchaseOrderStatuses.delivered],
                ["ordering", "date_issued"],
            ]}
            listEndpoint={PURCHASE_ORDER_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PURCHASE_ORDER_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="stocked"
            title="Stocked"
            phase="open"
            endpointKwargs={[
                ["status", PurchaseOrderStatuses.stocked],
                ["ordering", "date_issued"],
            ]}
            listEndpoint={PURCHASE_ORDER_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PURCHASE_ORDER_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="all_closed"
            title="All Closed"
            phase="closed"
            isDefaultActiveTabForPhase={true}
            endpointKwargs={[
                ["status", PurchaseOrderStatuses.paid],
                ["status", PurchaseOrderStatuses.cancelled],
                ["ordering", "date_issued"],
            ]}
            listEndpoint={PURCHASE_ORDER_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PURCHASE_ORDER_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="paid"
            title="Paid"
            phase="closed"
            endpointKwargs={[
                ["status", PurchaseOrderStatuses.paid],
                ["ordering", "date_issued"],
            ]}
            listEndpoint={PURCHASE_ORDER_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PURCHASE_ORDER_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="cancelled"
            title="Cancelled"
            phase="closed"
            endpointKwargs={[
                ["status", PurchaseOrderStatuses.cancelled],
                ["ordering", "date_issued"],
            ]}
            listEndpoint={PURCHASE_ORDER_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PURCHASE_ORDER_ROUTES.COUNT}
        />
    </ObjectsView.Tabs>
)
